import { Helmet } from "react-helmet"
import { PhoneLink, directionsLink } from '../../components/Shared/Links'
import Social from '../../components/Shared/Social'
import MailChimp from '../../components/Shared/Mailchimp'

export default function Contact(){
  return (
    <div className="pageStyles contact">
      <Helmet>
        <title>Contact Villaggio Grille at The Wharf in Orange Beach</title>
        <meta name="description" content="Villaggio Grille is located at The Wharf in Orange Beach. Contact us for more information about our menu, events, or reservations." />
      </Helmet>

      <div id="page-title" className="pt-bkg-image image-contact">
        <div className="overlay">
          <div className="title-container less">
            <h3>Villaggio Grille</h3>
            <h1>Contact Us</h1>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="sectionWrap medDef">
          <div className="row text-center">
            <div className="colItem info">
              <div className="fancy-heading center less"><h2>Contact</h2></div>
              <p className="inheritA"><b>Phone:</b><br /> <PhoneLink /></p>
              <p><b>Address:</b><br /> 4790 Main Street, Suite F 108-B <br /> Orange Beach, Al 36561</p>
              <a href={directionsLink} target="_blank" rel="noreferrer" className="p-link">Get Directions</a>
            </div>

            <div className="colItem hours">
              <div className="fancy-heading center"><h2>Our Hours:</h2></div>
              <p><b>Sunday-Wednesday:</b><br/> 11am-9pm</p>
              <p><b>Thursday-Saturday:</b><br/> 11am-10pm</p>
            </div>

            <div className="colItem follow">
              <div className="fancy-heading center"><h2>Stay Updated</h2></div>
              <MailChimp />
              <div className="fullSec socials">
                <Social />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12"><div className="hr hr-png-10"></div></div>
    </div>
  )
}
